'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _customSectionSharedFunctions = require('./customSectionSharedFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InFulfillmentOfsSection = function InFulfillmentOfsSection(_ref) {
  var inFulfillmentOfsArray = _ref.inFulfillmentOfsArray;

  var renderServiceOrder = function renderServiceOrder(serviceOrder, index) {
    return _react2.default.createElement(
      'li',
      { key: index },
      serviceOrder.ids && serviceOrder.ids.length > 0 ? _react2.default.createElement(
        'div',
        null,
        "Id(s): " + (0, _customSectionSharedFunctions.renderArray)(serviceOrder.ids)
      ) : null,
      _react2.default.createElement(
        'div',
        null,
        serviceOrder.code ? _react2.default.createElement(
          'span',
          null,
          serviceOrder.code
        ) : null,
        serviceOrder.code && serviceOrder.priorityCode ? _react2.default.createElement(
          'span',
          null,
          ", "
        ) : null,
        serviceOrder.priorityCode ? _react2.default.createElement(
          'span',
          null,
          "Priority: " + serviceOrder.priorityCode
        ) : null
      )
    );
  };

  var renderInFulfillmentOf = function renderInFulfillmentOf(InFulfillmentOf, index) {
    if (InFulfillmentOf && InFulfillmentOf.serviceOrder) return renderServiceOrder(InFulfillmentOf.serviceOrder, index);else return null;
  };

  return _react2.default.createElement(
    'div',
    { className: 'inFulfillmentOfsSection' },
    inFulfillmentOfsArray ? _react2.default.createElement(
      'ul',
      null,
      inFulfillmentOfsArray.map(renderInFulfillmentOf)
    ) : null
  );
};

InFulfillmentOfsSection.propTypes = {
  inFulfillmentOfsArray: _propTypes.array
};

exports.default = InFulfillmentOfsSection;


//////////////////
// WEBPACK FOOTER
// ./node_modules/updox-care-record-viewer/lib/reactComponents/customSections/InFulfillmentOfsSection.js
// module id = 1229
// module chunks = 0